export default "__VITE_ASSET__BTQo8K0L__"